import { createStore } from 'effector-root'
import { createFilter } from '@/pages/common/filter-dropdown/create-filter'
import { DropdownItem } from '@/pages/common/types'
import { mapCourseTaskCheckTypeFilter } from '@/pages/learning/learning-courses/constants'

export const courseCourseTaskCheckTypeDropdownModule = createFilter()
export const $courseCourseTaskCheckType = createStore<DropdownItem[]>(mapCourseTaskCheckTypeFilter)
